// ABOUTME: Shared signal vocabulary — color mapping and badge for alpha signals
// ABOUTME: STRONG_BUY → STRONG_SELL rendered as a colored pill, ranked for sorting

export const SIGNAL_COLORS: Record<string, string> = {
  STRONG_BUY: 'bg-emerald-100 text-emerald-800',
  BUY: 'bg-green-100 text-green-800',
  HOLD: 'bg-gray-100 text-gray-800',
  SELL: 'bg-red-100 text-red-800',
  STRONG_SELL: 'bg-rose-100 text-rose-800',
};

// Conviction order, ascending. Used to sort a Signal column.
export const SIGNAL_RANKS: Record<string, number> = {
  STRONG_SELL: 1,
  SELL: 2,
  HOLD: 3,
  BUY: 4,
  STRONG_BUY: 5,
};

// Turn a SCREAMING_SNAKE enum into a human label: "STRONG_BUY" → "Strong Buy".
function humanizeEnum(value: string): string {
  return value
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function signalLabel(signal: string): string {
  return humanizeEnum(signal);
}

// Entry-plan lifecycle states. Mapped explicitly so "WAIT_PULLBACK" reads as a
// phrase, not "Wait Pullback"; unknown states fall back to plain title-case.
const ENTRY_STATUS_LABELS: Record<string, string> = {
  IN_ZONE: 'In Zone',
  WAIT_PULLBACK: 'Wait for Pullback',
  EXTENDED: 'Extended',
  BELOW_ZONE: 'Below Zone',
};

export function entryStatusLabel(status: string): string {
  return ENTRY_STATUS_LABELS[status] ?? humanizeEnum(status);
}

export function SignalBadge({ signal }: { signal: string }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${SIGNAL_COLORS[signal] || SIGNAL_COLORS.HOLD}`}
    >
      {signalLabel(signal)}
    </span>
  );
}
